import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';

import GradientButton from 'src/components/elements/GradientButton';

import Input from '../../../components/Input';
import {
  NAME_FIELD_TEST_ID,
  PHONE_FIELD_TEST_ID,
  EMAIL_FIELD_TEST_ID,
  SUBMIT_BUTTON_TEST_ID,
} from '../../../constants/testId';
import { FormValues } from '../../../types';
import { formSchema } from '../schemas';

import styles from './ContactForm.scss';

type Props = {
  onSubmit?: SubmitHandler<FormValues>;
};

const ContactForm = ({ onSubmit }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: yupResolver(formSchema) });

  const onSubmitHandler: SubmitHandler<FormValues> = (data) => {
    if (onSubmit) {
      onSubmit(data);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className={styles.form}>
      <Input
        data-testid={NAME_FIELD_TEST_ID}
        id="name"
        placeholder="Name"
        errorLabel={errors.name?.message}
        register={register}
      />
      <Input
        data-testid={PHONE_FIELD_TEST_ID}
        id="phone"
        placeholder="Phone number"
        errorLabel={errors.phone?.message}
        register={register}
      />
      <Input
        data-testid={EMAIL_FIELD_TEST_ID}
        id="email"
        placeholder="Email"
        errorLabel={errors.email?.message}
        register={register}
      />
      <GradientButton
        data-testid={SUBMIT_BUTTON_TEST_ID}
        type="submit"
        className={styles.submitButton}
      >
        Submit
      </GradientButton>
    </form>
  );
};

export default ContactForm;
